
import type React from "react"

import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { useToast } from "@/hooks/use-toast"
import { useUser } from "@/contexts/user-context"
import { apiRequest } from "@/lib/api-client"

export function ProfileForm() {
  const { t } = useTranslation()
  const { toast } = useToast()
  const { user } = useUser()
  const [isLoading, setIsLoading] = useState(false)
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    phone: "",
  })

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || "",
        surname: user.surname || "",
        email: user.email || "",
        phone: user.phone || "",
      })
    }
  }, [user])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target
    setFormData((prev) => ({ ...prev, [id]: value }))
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      const response = await apiRequest({
        method: "PUT",
        url: "/users/profile",
        data: formData,
      })

      if (response) {
        toast({
          title: t("common.success"),
          description: t("profile.profileUpdated"),
        })
      }
    } catch (error) {
      console.error("Failed to update profile:", error)
      toast({
        title: t("common.error"),
        description: t("profile.updateFailed"),
        variant: "destructive",
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="name">{t("profile.firstName")}</Label>
          <Input id="name" value={formData.name} onChange={handleChange} required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="surname">{t("profile.lastName")}</Label>
          <Input id="surname" value={formData.surname} onChange={handleChange} required disabled />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">{t("profile.email")}</Label>
          <Input id="email" type="email" value={formData.email} onChange={handleChange} required disabled />
        </div>
        <div className="space-y-2">
          <Label htmlFor="phone">{t("profile.phone")}</Label>
          <Input id="phone" value={formData.phone} onChange={handleChange} required disabled/>
        </div>
      </div>
    {/*   <div className="flex justify-end">
        <Button type="submit" disabled={isLoading}>
          {isLoading ? t("common.loading") : t("profile.updateProfile")}
        </Button>
      </div> */}
    </form>
  )
}
